// extracted by mini-css-extract-plugin
export default {"label":"j6gAIH","container":"M8N6qU"};